import { HeroSection } from "./src/components/sections/HeroSection";
import { BackgroundSection } from "./src/components/sections/BackgroundSection";
import { SubsidySection } from "./src/components/sections/SubsidySection";
import { ProgramSection } from "./src/components/sections/ProgramSection";
import { CurriculumSection } from "./src/components/sections/CurriculumSection";
import { FlowSection } from "./src/components/sections/FlowSection";
import { ApplicationFlowSection } from "./src/components/sections/ApplicationFlowSection";
import { Footer } from "./src/components/layout/Footer";

export default function App() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <BackgroundSection />
      <SubsidySection />
      <ProgramSection />
      <CurriculumSection />
      <FlowSection />
      <ApplicationFlowSection />
      <Footer />
    </div>
  );
}